var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5031C0 5.5978 5.59782 0 12.5031 0H44.6539C51.5591 0 57.1569 5.59782 57.1569 12.5031V44.6539C57.1569 51.5591 51.5591 57.1569 44.6538 57.1569H12.5031C5.5978 57.1569 0 51.5591 0 44.6538V12.5031Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9139 17.8616H20.2432C18.9279 17.8616 17.8616 18.9278 17.8616 20.2431V36.9139C17.8616 38.2292 18.9279 39.2954 20.2432 39.2954H36.9139C38.2292 39.2954 39.2955 38.2292 39.2955 36.9139V20.2431C39.2955 18.9278 38.2292 17.8616 36.9139 17.8616Z",
    stroke: "#E7000B",
    strokeWidth: 2.38154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0062 27.3877C26.3215 27.3877 27.3878 26.3215 27.3878 25.0062C27.3878 23.6909 26.3215 22.6246 25.0062 22.6246C23.6909 22.6246 22.6247 23.6909 22.6247 25.0062C22.6247 26.3215 23.6909 27.3877 25.0062 27.3877Z",
    stroke: "#E7000B",
    strokeWidth: 2.38154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2954 32.1507L35.6207 28.476C35.1741 28.0296 34.5685 27.7787 33.937 27.7787C33.3055 27.7787 32.6998 28.0296 32.2532 28.476L21.4339 39.2954",
    stroke: "#E7000B",
    strokeWidth: 2.38154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery);
export default __webpack_public_path__ + "static/media/ic_gallery.927e0a1241be9aa95a6e9ee2e280554d.svg";
export { ForwardRef as ReactComponent };